import React from 'react';
import {Box, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';

import {useContextState} from '../../../../../context/sub-client';
import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';
import {FeePaymentDetailItem} from './detail-item';
import {PrimaryButton} from '../../../../../components/buttons';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'FeePaymentDetailScreen'
>;

const FeePaymentDetailScreen = ({navigation}: ScreenProps) => {
  const {invoiceFeeSummary} = useContextState();

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleAssignInvoiceFees = () => {
    navigation.navigate('FeePaymentOptionScreen');
  };

  const getForeignValue = () => {
    return invoiceFeeSummary?.amount.foreign ?? 0;
  };

  const getForeignIGTF = () => {
    return getForeignValue() * 0.03;
  };

  const getForeignTotal = () => {
    return getForeignValue() + getForeignIGTF();
  };

  const getLocalValue = () => {
    return invoiceFeeSummary?.amount.local ?? 0;
  };

  const getLocalIGTF = () => {
    return getForeignValue() * 0.03;
  };

  const getLocalTotal = () => {
    return getLocalValue() + getLocalIGTF();
  };

  return (
    <InternalTemplate
      title={'screen-fee-payment-detail'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back-screen',
        usage: 'external',
      }}>
      <VStack marginBottom={20}>
        <FeePaymentDetailItem
          label="Monto $"
          amount={getForeignValue()}
          isEven={false}
        />
        <FeePaymentDetailItem
          label="IGTF"
          amount={getForeignIGTF()}
          isEven={true}
        />
        <FeePaymentDetailItem
          label="Total $"
          amount={getForeignTotal()}
          isEven={false}
        />
        <Box marginTop={5}>
          <FeePaymentDetailItem
            label="Total Bs"
            amount={getLocalTotal()}
            isEven={false}
          />
        </Box>
        <Box marginTop={20} paddingX="10%">
          <PrimaryButton
            label="invoice-fees-action-button"
            onPress={() => handleAssignInvoiceFees()}
          />
        </Box>
      </VStack>
    </InternalTemplate>
  );
};
export default FeePaymentDetailScreen;
